import React from "react";
import { money } from "utils/helpers";
import "./styles.scss";

const CongratsTitle = ({ congratsOffer, numLenders }) => {
  if (numLenders > 1 && !congratsOffer) {
    return (
      <span>
        Congrats! You&apos;re pre-approved by some of our partners. Select one
        below to view more details.
      </span>
    );
  }
  return <span>Congrats! You&apos;re pre-approved!</span>;
};

const Subtitle = ({ fits, underAmount, overAmount, approved }) =>
  fits ? (
    <p className="cart-hero__subtitle">
      Your cart fits your ${money(approved)} approval with{" "}
      <span className="cart-hero__delta">${money(underAmount)} to spare</span>.
    </p>
  ) : (
    <p className="cart-hero__subtitle">
      Your cart is{" "}
      <span className="cart-hero__delta cart-hero__delta--over">
        ${money(overAmount)} over
      </span>{" "}
      your ${money(approved)} approval. Swap a tire or edit your cart below to
      checkout.
    </p>
  );

const ApprovalBar = ({ approved, cartTotal, fits }) => {
  const safeCart = cartTotal > 0 ? cartTotal : 1;
  const approvedPct = Math.min((approved / safeCart) * 100, 100);
  const overPct = Math.max(100 - approvedPct, 0);

  return (
    <div className="cart-hero__bar">
      <div className="cart-hero__bar-row">
        <span className="cart-hero__bar-item">
          <span className="cart-hero__bar-label">Approved</span>
          <span className="cart-hero__bar-value">${money(approved)}</span>
        </span>
        <span className="cart-hero__bar-item cart-hero__bar-item--right">
          <span className="cart-hero__bar-label">Cart</span>
          <span
            className={
              "cart-hero__bar-value" +
              (fits ? "" : " cart-hero__bar-value--over")
            }
          >
            ${money(cartTotal)}
          </span>
        </span>
      </div>
      <div
        className="cart-hero__progress"
        role="img"
        aria-label={`Approved $${money(approved)} of $${money(cartTotal)} cart`}
      >
        <div
          className="cart-hero__progress-fill cart-hero__progress-fill--approved"
          style={{ width: `${approvedPct}%` }}
        />
        {overPct > 0 && (
          <div
            className="cart-hero__progress-fill cart-hero__progress-fill--over"
            style={{ width: `${overPct}%` }}
          />
        )}
      </div>
    </div>
  );
};

const Hero = ({ congratsOffer, numLenders, selectedApproved, cartTotal }) => {
  const hasSelection = selectedApproved != null;
  const delta = hasSelection ? selectedApproved - cartTotal : 0;
  const fits = delta >= 0;
  const overAmount = Math.max(-delta, 0);
  const underAmount = Math.max(delta, 0);

  return (
    <>
      <div className="cart-hero">
        <div className="cart-hero__header">
          <h2 className="cart-hero__title">
            <CongratsTitle
              congratsOffer={congratsOffer}
              numLenders={numLenders}
            />
          </h2>
          {hasSelection && (
            <Subtitle
              fits={fits}
              underAmount={underAmount}
              overAmount={overAmount}
              approved={selectedApproved}
            />
          )}
        </div>
      </div>

      {hasSelection && (
        <div className="cart-hero__sticky">
          <ApprovalBar
            approved={selectedApproved}
            cartTotal={cartTotal}
            fits={fits}
          />
        </div>
      )}
    </>
  );
};

export default Hero;
